/**
 * Wave 78 · floating EN/PT toggle for the Vitrine.
 *
 * Lives top-right, ultra-low-key. Click flips locale, persists to
 * localStorage via the i18n hook, and instantly re-renders the strings
 * the components have wired up. Doesn't translate the prose vignettes —
 * those stay pt-BR (see lib/i18n.ts).
 */

import { useLocale } from '../lib/i18n';

export function LocaleToggle() {
  const [locale, setLocale] = useLocale();
  return (
    <div
      // Wave 299 — role=group + aria-label gives the language switcher
      // semantic meaning to screen readers; previously "PT"/"EN" was just
      // raw text in two unlabelled buttons.
      role="group"
      aria-label="Idioma da página / Page language"
      className="fixed top-4 right-4 z-40 select-none rounded-full border border-white/10 bg-black/35 px-1 py-1 text-[10px] uppercase tracking-[0.18em] backdrop-blur"
      style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
    >
      <button
        type="button"
        onClick={() => setLocale('pt-BR')}
        aria-label="Mudar para português"
        aria-pressed={locale === 'pt-BR'}
        // Wave 299 — Emil press feedback (scale 0.97 on :active) +
        // 44×44 effective hit area via min-height/width.
        className={`min-h-[36px] min-w-[36px] px-2 py-1 rounded-full transition-all duration-150 active:scale-[0.97] ${
          locale === 'pt-BR' ? 'bg-white/10 text-white' : 'text-white/55 hover:text-white'
        }`}
      >
        PT
      </button>
      <button
        type="button"
        onClick={() => setLocale('en')}
        aria-label="Switch to English"
        aria-pressed={locale === 'en'}
        className={`ml-1 min-h-[36px] min-w-[36px] px-2 py-1 rounded-full transition-all duration-150 active:scale-[0.97] ${
          locale === 'en' ? 'bg-white/10 text-white' : 'text-white/55 hover:text-white'
        }`}
      >
        EN
      </button>
    </div>
  );
}
